// extracted by mini-css-extract-plugin
export default {"link":"Checkout_link__Rt8Z6","steps":"Checkout_steps__OQANw","step":"Checkout_step__VJyPS"};